import { useSelector } from 'react-redux'

import { selectJBPSettings } from '../selectors/selectJBPSettings'

/** The fYears the user may switch to, as the JBP settings list them: in the classic fYear dropdown
 *  and in the cockpit alike. */
export const useAvailableFYears = () => {
  const { fYears } = useSelector(selectJBPSettings)

  return fYears
}
